import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { AlertCircle, Loader2 } from 'lucide-react';

interface MenuLoadingErrorProps {
  isLoading: boolean;
  error: string | null;
  t: any;
}

const MenuLoadingError = ({ isLoading, error, t }: MenuLoadingErrorProps) => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="pt-24 pb-20 bg-neutral-50"
    >
      <Helmet>
        <title>{t.menu.hero.title} | Rossopomodoro</title>
        <meta
          name="description"
          content={`${t.menu.hero.title} - ${t.menu.hero.subtitle}. Authentic Italian cuisine in Reykjavik.`}
        />
        <link rel="canonical" href="https://rossopomodoro.is/menu" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rossopomodoro.is/menu" />
        <meta property="og:title" content={`${t.menu.hero.title} | Rossopomodoro Reykjavik`} />
        <meta property="og:description" content={t.menu.hero.subtitle} />
        <meta property="og:image" content="https://rossopomodoro.is/hero11.jpg" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://rossopomodoro.is/menu" />
        <meta property="twitter:title" content={`${t.menu.hero.title} | Rossopomodoro Reykjavik`} />
        <meta property="twitter:description" content={t.menu.hero.subtitle} />
        <meta property="twitter:image" content="https://rossopomodoro.is/hero11.jpg" />
      </Helmet>
      <div className="container-custom">
        {isLoading ? (
          <div className="flex justify-center items-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-red-800" />
            <span className="ml-2 text-neutral-600">Loading menu...</span>
          </div>
        ) : (
          <div className="flex justify-center items-center py-20">
            <div className="text-center">
              <AlertCircle className="w-12 h-12 text-red-600 mx-auto mb-4" />
              <p className="text-neutral-600 mb-4">Failed to load menu</p>
              <p className="text-sm text-neutral-500">{error}</p>
            </div>
          </div>
        )}
      </div>
    </motion.section>
  );
};

export default MenuLoadingError;
